import { render, staticRenderFns } from "./NumberTextField.vue?vue&type=template&id=201f83ef&scoped=true&"
import script from "./NumberTextField.vue?vue&type=script&lang=js&"
export * from "./NumberTextField.vue?vue&type=script&lang=js&"
import style0 from "./NumberTextField.vue?vue&type=style&index=0&id=201f83ef&scoped=true&lang=scss&"
import style1 from "./NumberTextField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201f83ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
